import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AccessDenied: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
        <div className="text-6xl mb-4">🚫</div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          {t("access_denied.title", "Доступ запрещен")}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {t(
            "access_denied.message",
            "У вас нет прав для доступа к этой странице"
          )}
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {t("access_denied.back_to_dashboard", "Вернуться на главную")}
        </Link>
      </div>
    </div>
  );
};

export default AccessDenied;
